import {
  Base64URLDecode,
  Base64URLEncode,
  JSONDecode,
  JSONEncode,
  StringToUInt8,
  UInt8ToString,
} from "@pdfking/tfunc"

export default {
  dumps: (s: any) => Base64URLEncode(StringToUInt8(JSONEncode(s))),
  loads: (s: string) => JSONDecode(UInt8ToString(Base64URLDecode(s))),
}
